/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlInfoTrackSetupStateQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GqlInfoTrackSetupStateQuery = {
  __typename: "Query";
  infoTrackSetupState?: {
    __typename: "InfoTrackSetupState";
    authorized: boolean;
  } | null;
};

export const InfoTrackSetupStateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "infoTrackSetupState" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "infoTrackSetupState" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "infoTrackSetupStateFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "infoTrackSetupStateFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InfoTrackSetupState" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "authorized" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlInfoTrackSetupStateQuery,
  GqlInfoTrackSetupStateQueryVariables
>;
